var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Englisch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 8,
    cy: 8,
    r: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags-/Englisch",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1023",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fill: "#28376A",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-127",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.847200, -0.228800)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-118",
    fill: "#FFFFFE",
    points: "28.6216 16.4576 0 2.1464 1.0728 0 29.6944 14.3112 28.6216 16.4576"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-120",
    fill: "#C1242D",
    points: "0.1784 1.7888 14.4896 8.944 14.8472 8.2288 0.536 1.0736 0.1784 1.7888"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-121",
    fill: "#C1242D",
    points: "15.2048 7.5136 14.8472 8.2288 29.1584 15.384 29.516 14.6688 15.2048 7.5136"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-122",
    fill: "#FFFFFE",
    points: "29.6944 2.1464 1.0728 16.4576 0 14.3112 28.6216 0 29.6944 2.1464"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-123",
    fill: "#C1242D",
    points: "0.8944 16.1 15.2048 8.944 14.8472 8.2288 0.536 15.384 0.8944 16.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-124",
    fill: "#C1242D",
    points: "14.4896 7.5136 14.8472 8.2288 29.1584 1.0736 28.8 0.3576 14.4896 7.5136"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-125",
    fill: "#FFFFFE",
    points: "28.8472 6.2288 16.8472 6.2288 16.8472 0.2288 12.8472 0.2288 12.8472 6.2288 0.8472 6.2288 0.8472 10.2288 12.8472 10.2288 12.8472 16.2288 16.8472 16.2288 16.8472 10.2288 28.8472 10.2288 28.8472 6.2288"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-126",
    fill: "#C1242D",
    points: "28.8472 7.0288 16.0472 7.0288 16.0472 0.2288 13.6472 0.2288 13.6472 7.0288 0.8472 7.0288 0.8472 9.4288 13.6472 9.4288 13.6472 16.2288 16.0472 16.2288 16.0472 9.4288 28.8472 9.4288 28.8472 7.0288"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.0d3a1448e10bcf9cb9a327627f9cbe31.svg";
export { ForwardRef as ReactComponent };